import { Box, Grid2 as Grid, Typography } from "@mui/material";
import { PSTrackerIcon, LogoAlisaIcon, LogoLDIcon, LogoRegioneIcon } from "../../styles/images";

export const SplashScreen = () => {
  const fromSaluteSimplex = window.ReactNativeWebView != null;

  return (
    <Box className="splashScreen">
      <Typography variant="h1" sx={{ height: 0 }}>
        <div style={{ display: "none" }}>Splash screen</div>
      </Typography>
      <Grid container>
        <Grid size={12} className="logo" sx={{ height: fromSaluteSimplex ? "100%" : "calc(100% - 150px)" }}>
          <PSTrackerIcon />
        </Grid>
        {!fromSaluteSimplex && (
          <Grid container spacing={2} size={12} className="splashFooter">
            <Grid size={4} className="logoRegione">
              <LogoRegioneIcon />
            </Grid>
            <Grid size={4} className="logoAlisa">
              <LogoAlisaIcon />
            </Grid>
            <Grid size={4} className="logoLD">
              <LogoLDIcon />
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
